import type { QueryClient } from '@tanstack/react-query';
import { mutationOptions, queryOptions } from '@tanstack/react-query';
import { userAPIClient } from '../userAPIClient';
import { USER_QUERY_KEYS } from './keys';
import type { GetUserMeResponse, UpdateUserRequest, UpdateUserResponse } from './types';

export const USER_QUERIES = {
  getMe: () =>
    queryOptions<GetUserMeResponse>({
      queryKey: USER_QUERY_KEYS.getMe(),
      queryFn: () => userAPIClient.getMe(),
    }),
  confirmGuest: () =>
    mutationOptions<GetUserMeResponse, Error, void>({
      mutationFn: () => userAPIClient.getMe(true),
    }),
  getMeMutation: (queryClient: QueryClient) =>
    mutationOptions<GetUserMeResponse, Error, void>({
      mutationKey: USER_QUERY_KEYS.getMe(),
      mutationFn: () => userAPIClient.getMe(),
      onSuccess: (data) => {
        queryClient.setQueryData(USER_QUERY_KEYS.getMe(), data);
      },
    }),
  updateUserMutation: (queryClient: QueryClient) =>
    mutationOptions<UpdateUserResponse, Error, UpdateUserRequest>({
      mutationKey: USER_QUERY_KEYS.updateUser(),
      mutationFn: (payload: UpdateUserRequest) => userAPIClient.updateUser(payload),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: USER_QUERY_KEYS.getMe() });
      },
    }),
};
